import styled from 'styled-components';
import Header from './Header';

export default styled(Header)`
  margin-top: 24px;
  display: flex;
  flex-direction: row;

  .reference {
    border-radius: 0.4rem;
    padding: 0.8rem;
    border: solid 1px var(--grey-mouse);
    display: flex;
    justify-content: center;
    flex-direction: column;

    &__label {
      font-size: 14px;
      text-align: center;
      color: var(--grey700);
    }

    &__shipment-id {
      text-transform: uppercase;
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0.7px;
      text-align: center;
      color: var(--grey900);
    }
  }

  .pallets {
    margin-left: 0.8rem;
    padding: 0.8rem;
    font-size: 16px;
    font-weight: 500;
    color: var(--grey700);
  }
`;
